module.exports = __webpack_public_path__ + "img/588x310-02.f1fdf68a.png";